import { SEARCH_DASHBOARD_API } from '~/constants/APIs'
import { IDashboardPage, IDashboardSearchRequest } from '~/models'
import axiosClient from './axiosClient'

export const dashboardApi = {
  searchDashboard: (data: IDashboardSearchRequest) =>
    axiosClient.get(SEARCH_DASHBOARD_API, { params: data }) as unknown as IDashboardPage
}
